import { render, staticRenderFns } from "./UCreateWorkshop.vue?vue&type=template&id=55b058b3&scoped=true&"
import script from "./UCreateWorkshop.vue?vue&type=script&lang=js&"
export * from "./UCreateWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./UCreateWorkshop.vue?vue&type=style&index=0&id=55b058b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b058b3",
  null
  
)

export default component.exports